<div class="main-component-container main-margin" *ngIf="initialRender == false">

  <div class="page-header">
    <div class="component-header-left-container">
      <img  class="component-header-gear-icon" src="../../../assets/generic/settings_gear_white.svg">
    </div>

    <p class="new-contact-text">{{currentContactInfoType == ContactInfoType.CREATING ? ('New Contact' | translate) : userContact.nickname}}</p>

    <div class="component-header-right-container">
      <img  class="component-header-gear-icon" src="../../../assets/generic/settings_gear_white.svg">
    </div>
  </div>

  <div class="component-content-container">
    
    <div class="component-content-border-container">
      <div *ngIf="false" class="contact-profile-icon-container">
        <div class="profile-icon-container">
          <img class="profile-icon" [src]="'../../../assets/profile_icons/1.svg'">
         </div>
      </div>
      
      <div class="contact-info-container">
        <div class="contact-info-inputs-container">


          <!--Nickname-->
          <div class="bl-input-container bl-input" data-tutorial-target="contact-info-nickname">
            <p *ngIf="nicknameHasError" class="bl-mat-label bl-mat-label-error">{{ 'Nickname must be between 1 and 50 characters!' | translate }}</p>
            <mat-form-field appearance="fill">
              <input maxlength="50" [(ngModel)]="userContact.nickname" maxlength="320" id="nickname" (touchend)="$event.stopPropagation()" matInput [placeholder]="'Nickname' | translate">
            </mat-form-field>
         </div>
 
         <!--Friend Code-->
         <ng-container *ngIf="currentContactInfoType == ContactInfoType.CREATING && userContact.status == UserContactStatus.CREATING">

          <div class="bl-input-container contact-info-input-container" data-tutorial-target="contact-info-method">
            <p class="bl-mat-label">{{ 'Add contact method?' | translate }}</p>
            <mat-form-field appearance="fill">
              <mat-select [(ngModel)]="addContactMethod" [placeholder]="'Add contact method?' | translate" (touchend)="$event.stopPropagation()" (selectionChange)="onMethodChange($event)">
                  <mat-option [value]="AddContactMethod.email">{{ 'Email' | translate }}</mat-option>   
                  <mat-option [value]="AddContactMethod.code">{{ 'Friend Code' | translate }}</mat-option>   
              </mat-select>
            </mat-form-field>

          </div>


          <ng-container *ngIf="addContactMethod == AddContactMethod.email">
            <div class="bl-input-container contact-info-input-container" data-tutorial-target="contact-info-email">
              <p *ngIf="emailHasError" class="bl-mat-label bl-mat-label-error">{{ 'Contact Email' | translate }}</p>
              <mat-form-field appearance="fill">
                 <input [(ngModel)]="newContactEmail" maxlength="320"  (touchend)="$event.stopPropagation()" matInput [placeholder]="'Contact Email' | translate">
               </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngIf="addContactMethod == AddContactMethod.code">
            <div class="bl-input-container contact-info-input-container" data-tutorial-target="contact-info-code">
              <p *ngIf="friendCodeHasError" class="bl-mat-label bl-mat-label-error">{{ 'You must enter a friend code!' | translate }}</p>
              <mat-form-field appearance="fill">
                 <input maxlength="20" [(ngModel)]="newContactFriendCode" maxlength="320" id="friendCode" (touchend)="$event.stopPropagation()" matInput [placeholder]="'Friend Code' | translate">
               </mat-form-field>
            </div>
    
            <div class="bl-input-container contact-info-input-container">
              <div class="solis-code-container">
                <p class="bl-mat-label">{{ 'Your Friend Code' | translate }}</p>
                <img (click)="copyToClipboard(userAuthService.currentUserComplete.user.friendCode,matSnackBar)" class="copy-clipboard-img" src="../../../assets/generic/copy_clipboard_white.png">
    
              </div>
              <mat-form-field appearance="fill">
                <input [disabled]="true" [value]="userAuthService.currentUserComplete.user.friendCode" maxlength="320" id="userFriendCode" (touchend)="$event.stopPropagation()" matInput [placeholder]="'Friend Code' | translate">
              </mat-form-field>
            </div>
          </ng-container>
          

         </ng-container>
         
 
        </div>
 
        <div class="contact-info-buttons-container">

          <ng-container *ngIf="userContact.status != UserContactStatus.DELETED">
            <button class="max-btn mat-primary-lighter" (click)="finish()" mat-button mat-raised-button color="primary"
              data-tutorial-target="contact-info-finish"
              [disabled]="currentContactInfoType == ContactInfoType.PENDINGNOTIFICATION && contactRequestDetailsLoading">
              {{
                currentContactInfoType == ContactInfoType.CREATING ? ('Send Contact Request' | translate) :
                (currentContactInfoType == ContactInfoType.PENDINGNOTIFICATION ? ('Accept Request' | translate) : ('Update Contact' | translate))
              }}
            </button>
            <button *ngIf="currentContactInfoType != ContactInfoType.CREATING" class="max-btn" (click)="deleteContact()" mat-button mat-raised-button color="warn">
              {{
                currentContactInfoType == ContactInfoType.PENDINGNOTIFICATION ? ('Delete Request' | translate) : ('Delete Contact' | translate)
              }}
            </button>
          </ng-container>

          <ng-container *ngIf="userContact.status == UserContactStatus.DELETED">
            <button *ngIf="currentContactInfoType == ContactInfoType.UPDATING" class="max-btn mat-primary-lighter" (click)="finish()" mat-button mat-raised-button color="primary">{{ 'Send Contact Request' | translate }}</button>

          </ng-container>
         
        </div>
      </div>
  
      
  
    </div>
   
  </div>

  


 
</div>
